import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@/lib/theme'
import { AuthProvider } from '@/lib/auth/AuthContext'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { ConsentNotice } from '@/components/legal/ConsentNotice'
import { Toaster } from '@/components/ui/sonner'
import LandingPageV2 from './pages/LandingPageV2'
import Dashboard from './pages/Dashboard'
import AuthPage from './pages/AuthPage'
import EmailVerificationPage from './pages/EmailVerificationPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import CheckoutPage from './pages/CheckoutPage'
import CheckoutSuccessPage from './pages/CheckoutSuccessPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import RoadmapPage from './pages/RoadmapPage'
import AdminDashboard from './pages/admin/AdminDashboard'
import UnsubscribePage from './pages/email/UnsubscribePage'
import EmailPreferencesPage from './pages/email/EmailPreferencesPage'
import LiveWorkspace from './pages/LiveWorkspace'
import GraphLab from './pages/GraphLab'
import SpectatorWorkspace from './pages/SpectatorWorkspace'
import SpectatorAliasRedirect from './pages/SpectatorAliasRedirect'
import ReportViewerPage from '@/pages/ReportViewerPage'
import ReportsListPage from '@/pages/ReportsListPage'
import PublicReportPage from '@/pages/PublicReportPage'
import WorkspaceReportsPage from './pages/WorkspaceReportsPage'

const queryClient = new QueryClient()

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="ecosemantic-theme">
      <QueryClientProvider client={queryClient}>
        <Router>
          <AuthProvider>
            <div className="min-h-screen bg-background text-foreground">
              <Routes>
                <Route path="/" element={<LandingPageV2 />} />
                <Route path="/auth" element={<AuthPage />} />
                <Route path="/login" element={<AuthPage />} />
                <Route path="/verify-email" element={<EmailVerificationPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
                <Route path="/cookies" element={<CookiePolicyPage />} />
                <Route path="/roadmap" element={<RoadmapPage />} />
                <Route path="/email/unsubscribe" element={<UnsubscribePage />} />
                <Route path="/email/preferences" element={<EmailPreferencesPage />} />
                <Route path="/live/a/:alias" element={<SpectatorAliasRedirect />} />
                <Route path="/live/:shareId" element={<SpectatorWorkspace />} />
                <Route path="/r/:token" element={<PublicReportPage />} />
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/workspace"
                  element={
                    <ProtectedRoute>
                      <LiveWorkspace />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/workspace/reports"
                  element={
                    <ProtectedRoute>
                      <WorkspaceReportsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/workspace/reports/:reportId"
                  element={
                    <ProtectedRoute>
                      <WorkspaceReportsPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/graph-lab"
                  element={
                    <ProtectedRoute>
                      <GraphLab />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports"
                  element={
                    <ProtectedRoute>
                      <ReportsListPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/reports/:reportId"
                  element={
                    <ProtectedRoute>
                      <ReportViewerPage />
                    </ProtectedRoute>
                  }
                />
              </Routes>
              <ConsentNotice />
              <Toaster position="top-right" expand={true} richColors closeButton />
            </div>
          </AuthProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

export default App
